import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {MatSelectChange} from '@angular/material/select';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {Regional} from '../../interface/regional';
import {RegionalService} from '../../services/regional.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-dict-regionals',
  templateUrl: './dict-regionals.component.html',
  styleUrls: ['./dict-regionals.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictRegionalsComponent)}
  ]
})
export class DictRegionalsComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() noneEntry = false;
  @Input() disable = false;


  externalControl = true;
  disabled = false;
  items: Regional[] = [];
  value?: number = null;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private regionalService: RegionalService) { }

  ngOnInit(): void {
    this.regionalService.getRegionalsDictSubject()
      .pipe(first())
      .subscribe((items: Regional[]) => {
        this.items = items;
        this.items.sort((a, b) => {
          return (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName);
        });
      });

    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }
}
